import { render, staticRenderFns } from "./success.vue?vue&type=template&id=eb72cbf2&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb72cbf2",
  null
  
)

export default component.exports